export default "__VITE_ASSET__5AGPx1HV__"